import { useQuery } from '@apollo/react-hooks';
import { useMe } from 'hooks/useMe';
import { query as GET_ACCOUNTS } from 'pages/app/Accounts/gql/queries/get-accounts';

// Shared shape for the v3 account switcher dropdown:
//   { id, initials, name, sub }
// Two variants below feed the same UI from different data sources.

// Initials from a business name (up to 2 words): "Angell Park Speedway" -> "AP".
export function venueInitials(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return parts
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

// Subtitle from an account's physical (track) address: "City, ST".
export function venueSub(addr) {
  if (!addr) return '';
  return [addr.city, addr.state].filter(Boolean).join(', ');
}

function toVenue(a) {
  return {
    id: a.id,
    initials: venueInitials(a.business_dba || a.legal_name),
    name: a.business_dba || a.legal_name || 'Account',
    sub: venueSub(a.track),
  };
}

// Track / Employee variant — the signed-in user's OWN accounts (the set they
// can switch the app's active account between).
export function useTrackAccountVenues() {
  const { data, loading } = useMe();
  const accounts = (data && data.me && data.me.accounts) || [];
  return { venues: accounts.map(toVenue), loading };
}

// Admin variant — EVERY active account in the system.
export function useAdminAccountVenues() {
  const { data, loading } = useQuery(GET_ACCOUNTS, {
    variables: { input: { limit: 1000 } },
  });
  const results = (data && data.getAccounts && data.getAccounts.results) || [];
  const active = results.filter((a) => !a.inactive);
  return { venues: active.map(toVenue), loading };
}
